<router-outlet />

<av-global-loader />
